import React from "react"
import styled from "styled-components"
import Fade from "react-reveal/Fade"

const ProjectsSectionWrapper = styled.section`
  background-color: var(--primary-color);
  padding: 80px 0;
  color: var(--four-color);

  @media only screen and (max-width: 767px) {
    padding: 60px 0;
  }
`

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.9fr);
  grid-gap: 3em;
  align-items: flex-start;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    grid-gap: 2.5em;
  }
`

const IntroColumn = styled.div`
  max-width: 540px;
  margin-bottom: 32px;
`

const ProjectsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 20px;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`

const SectionLabel = styled.span`
  display: inline-block;
  margin-bottom: 10px;
  font-family: var(--font-md);
  font-size: 0.85em;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--primary-light-color);
`

const SectionTitle = styled.h2`
  margin: 0 0 16px 0;
  font-family: var(--font-bold);
  font-size: 2.1em;
  text-transform: uppercase;
  color: var(--four-color);
`

const SectionIntro = styled.p`
  margin: 0;
  font-family: var(--font-md);
  font-size: 1em;
  line-height: 1.9em;
  max-width: 540px;
`

const ProjectItem = styled.article`
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 14px 18px 18px;

  @media only screen and (max-width: 767px) {
    padding: 12px 14px 16px;
  }
`

const ProjectTitleBar = styled.h3`
  margin: 0 0 8px 0;
  padding: 8px 12px;
  background-color: #000000;
  font-family: var(--font-bold);
  font-size: 0.95em;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--four-color);
`

const ProjectText = styled.p`
  margin: 6px 0 0 0;
  font-family: var(--font-md);
  font-size: 0.95em;
  line-height: 1.7em;
`

const BulletList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 1.1em;
  font-family: var(--font-md);
  font-size: 0.95em;
  line-height: 1.7em;
`

const RepresentativeProjectsSection = () => {
  const projects = [
    {
      title:
        "Citybus Oaxaca – Estructuración integral de sistema de transporte",
      description:
        "Lideramos el diseño y la estructuración integral del sistema de transporte masivo más innovador del sureste mexicano. Este proyecto incluyó la coordinación estratégica con autoridades estatales, el desarrollo de estudios de impacto ambiental, la estructuración financiera y la supervisión de la implementación operativa.",
    },
    {
      title: "Estudios de preinversión en Querétaro",
      description:
        "Desarrollamos análisis financiero, técnico y de viabilidad social para múltiples proyectos de desarrollo urbano en Querétaro. Nuestro trabajo incluyó la evaluación de impacto socioeconómico, el análisis de factibilidad técnica y recomendaciones estratégicas para optimizar el uso de recursos públicos.",
    },
    {
      title: "Sistemas de transporte CDMX y Edomex",
      description:
        "Proporcionamos asesoría especializada en la estructuración y operación de sistemas masivos de transporte en Ciudad de México y Estado de México, con análisis de optimización operativa, evaluación financiera y propuestas de mejora continua.",
    },
    {
      title:
        "Energía – Estructuras de financiamiento para empresas del sector energético",
      description:
        "Diseñamos estructuras de financiamiento innovadoras para empresas del sector energético, incluyendo proyectos de generación y distribución, portafolios energéticos y contratos de largo plazo, como Proyecto Chicoasén II, Suministradores de Energía y Ducto Gas.",
    },
    {
      title: "Aeropuerto Intercontinental de Querétaro",
      bullets: [
        "Dictamen legal para inversiones futuras.",
        "Estrategias de inversión para ampliación de instalaciones.",
      ],
    },
    {
      title: "Estado de México",
      bullets: [
        "Supervisión y dictamen de cumplimiento de obligaciones en concesiones de transporte público.",
        "Evaluación del Ingreso Total Pendiente de Recuperar (ITPR) en concesiones carreteras.",
      ],
    },
    {
      title: "Constructoras",
      bullets: [
        "Estudios y supervisión del cumplimiento de obligaciones en contratos de prestación de servicios.",
        "Concesiones de carreteras en Puebla, Querétaro, Michoacán y otros estados.",
      ],
    },
    {
      title: "Estructuras del mercado de valores",
      bullets: [
        "Diseño, estructuración y colocación de cartera hipotecaria y de consumo.",
        "Flujos de concesiones y monetización de contratos de prestación de servicios.",
      ],
    },
  ]

  return (
    <ProjectsSectionWrapper>
      <div className="container">
        <Fade up>
          <IntroColumn>
            <SectionLabel>Experiencia</SectionLabel>
            <SectionTitle>Proyectos representativos</SectionTitle>
            <SectionIntro>
              Nuestro portafolio de proyectos representativos demuestra la
              diversidad y complejidad de las iniciativas que hemos liderado
              exitosamente. Cada proyecto ha contribuido significativamente al
              desarrollo de infraestructura y servicios en México, generando
              impacto positivo en las comunidades y creando valor sostenible
              para todos los participantes involucrados.
            </SectionIntro>
          </IntroColumn>
          <ProjectsList>
            {projects.map(project => (
              <ProjectItem key={project.title}>
                <ProjectTitleBar>{project.title}</ProjectTitleBar>
                {project.description && (
                  <ProjectText>{project.description}</ProjectText>
                )}
                {project.bullets && (
                  <BulletList>
                    {project.bullets.map(item => (
                      <li key={item}>{item}</li>
                    ))}
                  </BulletList>
                )}
              </ProjectItem>
            ))}
          </ProjectsList>
        </Fade>
      </div>
    </ProjectsSectionWrapper>
  )
}

export default RepresentativeProjectsSection
